<template>
  <page-layout class="tnmt_detail">

    <!-- content -->
    <div class="detail_con" id="results" v-show="!loading" v-if="tournament">

      <article class="tnmt_top">
        <div class="inner">

          <div class="tnmt_box">
            <div class="venue_wrap">
              <div v-if="isFileExist(tournament.poster_img)" class="venue">
                <div class="img"><img :src="getFileExist(tournament.poster_img)" class="full-width"></div>
              </div>
              <h3 v-html="tournament.title"></h3>
              <ul class="detail">
                <div v-html="tournament.info"></div>
                <a class="btn_view" v-for="file in tournament.imgs" :key="file.id" @click="showFile(file)">{{ getFileName(file) }}</a>
              </ul>
              <ul class="logo" v-if="isFileExist(tournament.brand_logo_img)">
                <div class="img"><img :src="getFileExist(tournament.brand_logo_img)"></div>
              </ul>
            </div>

            <div class="info_wrap">
              <div class="info">
                <p>대회 일정은 주최 측 사정에 따라 변경될 수 있습니다. <span>항공권·숙박 예약 전 공식 채널에서 최신 일정을 확인해주세요.</span></p>
              </div>
            </div>

            <!-- 신규 콘텐츠 202504 -->
            <div class="con_series">

              <!-- Live Reporting -->
              <div class="section reporting" v-if="tournament.live_reporting && tournament.live_reporting.length > 0">
                <p class="title">Live Reporting</p>
                <div class="ctnr_rep" v-for="reporting in tournament.live_reporting" :key="reporting.idx">
                  <p class="event">{{ reporting.title }}</p>
                  <router-link v-for="(day, index) in getDaysTabData(reporting.days.data)" :key="index" :to="`/live/reporting/${reporting.idx}?tab=0&day=${day.idx}`" class="rep">{{day.title}}</router-link>
                </div>
              </div>

              <!-- Latest News -->
              <div class="section news" v-if="tournament.articles && tournament.articles.length > 0">
                <p class="title">Latest News</p>
                <div class="sect_wrap news" :style="`height: ${getNewsHeight};`">
                  <router-link v-for="article in tournament.articles" :key="article.idx" :to="`/article/${article.idx}`" class="ctnr_news">
                    <p class="img"><img class="fit_img" v-if="isFileExist(article.post_img)" :src="article.post_img.url"></p>
                    <p class="cate">{{ article.post_cate_txt }}</p>
                    <p class="subj">{{ article.title }}</p>
                  </router-link>
                </div>
                <a class="lst_more" v-if="getNewsCnt > 8 && !getMoreNews && getAccess === 'pc'" @click="moreNews = !moreNews" >Load More Articles</a>
              </div>

              <!-- Photo Gallery -->
              <div class="section gallery" v-if="tournament.galleries && tournament.galleries.length > 0">
                <p class="title">Photo Gallery</p>
                <div class="sect_wrap">
                  <router-link v-for="album in tournament.galleries" :key="album.idx" :to="`${album.link_url}`" class="ctnr_gallery">
                    <p class="img"><img class="fit_img" v-if="isFileExist(album.poster_img)" :src="album.poster_img.url"></p>
                    <p class="subj">{{ album.title }}</p>
                    <p class="count">{{ album.image_cnt }} Photos</p>
                  </router-link>
                </div>
              </div>

              <!-- Infographic -->
              <div class="section info" v-if="tournament.infographics && tournament.infographics.length > 0">
                <p class="title">Infographic</p>
                <div class="sect_wrap">
                  <div v-for="info in tournament.infographics" :key="info.idx" class="ctnr_info" @click="showModal(info)">
                    <p class="img"><img class="fit_img" v-if="isFileExist(info.feed_img)" :src="info.feed_img.url"></p>
                  </div>
                </div>
              </div>

              <!-- Previous Series -->
              <div class="section pre" v-if="tournament.previous_series && tournament.previous_series.length > 0">
                <p class="title">Previous Series</p>
                <!-- 최대 4개 -->
                <router-link v-for="series in tournament.previous_series" :key="series.idx" :to="`/tournament/${series.idx}`" class="ctnr_pre">
                  <p class="series">{{ series.title }}</p>
                  <p class="flag" v-if="series.flag_code"><img :src="`/statics/img/flags/${series.flag_code}.svg`"></p>
                  <p class="date">{{ series.date }}</p>
                  <p class="loc">{{ series.venue }}{{ series.country_name && `, ${series.country_name}` }}</p>
                </router-link>
              </div>

            </div>

            <!-- Infographic Modal -->
            <q-dialog ref="info" @hide="showImgUrl = ''">
              <div class="market_pop">
                <a class="close_btn" @click="$refs.info.hide()"></a>
                <div class="img">
                  <img v-if="showImgUrl" :src="showImgUrl">
                </div>
              </div>
            </q-dialog>
            <!--// 신규 콘텐츠 202504 끝 -->

            <h5 v-if="tournament.events.length > 0">Event Schedule</h5>
            <!--<h6 class="p-hide">23.11.23(목)</h6>-->
            <table class="sche-table table-in" v-if="tournament.events.length > 0">
              <tr class="caption">
                <th>Date</th>
                <th>Time</th>
                <th>Event</th>
                <th>Buy-in {{ tournament.currency_code && `(${tournament.currency_code})`}}</th>
                <th :class="{hide_usd: !isExistUSD}">USD<em>(REF. ONLY)</em></th>
                <th>Stack</th>
                <th>Clock</th>
                <th>Late Reg</th>
              </tr>
              <tr class="event"
                  v-for="(event, index) in tournament.events" :key="index"
                  :ref="`event_${event.idx}`"
                  :class="[{ on: eventIdxs.includes(event.idx) }, event.highlight ]"
                  @click="clickEventRow(event)">
                <td class="date" :rowspan="event.rowspan" v-if="event.rowspan > 0">{{ event.date }}</td>
                <td class="time">{{ event.time }}</td>
                <!--<td class="name" :style="event.highlight && `background: linear-gradient(to right, ${event.highlight}) !important`">-->
                <td class="name">
                  <p v-if="event.detail || event.imgs.length > 0">{{ event.title }}<em>{{ event.subtitle && `- ${event.subtitle}` }}</em></p>
                  <span v-else>{{ event.title }}<em>{{ event.subtitle && `- ${event.subtitle}` }}</em></span>

                  <div class="detail" v-show="eventIdxs.includes(event.idx)" v-if="event.detail || event.imgs.length > 0">
                    <div v-html="event.detail"></div>
                    <a class="btn_view_detail" v-for="file in event.imgs" :key="file.id" @click="showFile(file)">{{ getFileName(file) }}</a>
                  </div>
                </td>
                <td class="buyin"><!--{{ tournament.currency_code }}-->{{ event.buy_in | comma }}</td>
                <td class="usd" :class="{hide_usd: !isExistUSD}">{{ event.buy_in_usd ? event.buy_in_usd : '' | comma }}</td>
                <td class="stack">{{ event.starting_chips | comma }}</td>
                <td class="clock">{{ event.level }}</td>
                <td class="late-reg">{{ event.late_reg }}</td>
              </tr>
            </table>
          </div>

        </div>
      </article>
      <!-- //tnmt_box -->


      <!-- event schedule -->
      <!--<article class="schedule" ref="BENEFIT">
        <div class="inner">
          <h3>이벤트 상세 일정</h3>
        </div>

        <table class="sche-table inner">
          <tr class="caption">
            <th>Date</th>
            <th>Time</th>
            <th>Event</th>
            <th>Buy-in(VND)</th>
            <th>USD</th>
            <th>Stack</th>
            <th>Clock</th>
            <th>Late Reg</th>
          </tr>
          <tr class="event"
              v-for="(event, index) in tournament.events" :key="index"
              :ref="`event_${event.idx}`"
              :class="{ on: eventIdxs.includes(event.idx) }"
              @click="clickEventRow(event)">
            <td class="date">{{ event.date }}</td>
            <td class="time">10:00</td>
            <td class="name">
              <p>{{ event.title }}<em>- play Down to 12.5%</em></p>
              <div class="detail" v-show="eventIdxs.includes(event.idx)">
                <div v-html="event.detail"></div>
                <a class="btn_view_detail" v-for="file in event.imgs" :key="file.id" @click="showFile(file)">{{ getFileName(file) }}</a>
              </div>
            </td>
            <td class="buyin">VND 500,000</td>
            <td class="usd">{{ event.buy_in | comma }}</td>
            <td class="stack">{{ event.starting_chips | comma }}</td>
            <td class="clock">{{ event.level }}</td>
            <td class="late-reg">Level 11 @16:40</td>
          </tr>
        </table>

        <div class="lst inner">
          <dl v-for="(event, index) in tournament.events" :key="index"
              :ref="`event_${event.idx}`"
              :class="{ on: eventIdxs.includes(event.idx) }">
            <dt @click="clickEventRow(event)">
              <p>{{ event.date }}</p>
              <p>{{ event.days }} Day{{ event.days > 1 ? 's' : '' }}</p>
              <p class="name">{{ event.title }}</p>
              <p>{{ event.buy_in | comma }}</p>
            </dt>
            <dd v-show="eventIdxs.includes(event.idx)">
              <div class="in_box">
                <div v-html="event.detail"></div>
                <a class="btn_view_detail" v-for="file in event.imgs" :key="file.id" @click="showFile(file)">{{ getFileName(file) }}</a>
              </div>
            </dd>
          </dl>
        </div>
        <div class="lst_info inner">
        </div>
      </article>-->
      <!-- //event schedule -->

    </div>
    <!-- //content -->

    <!-- detail modal -->
    <q-dialog v-model="dialog.open" :maximized="dialog.maximized">
      <div v-if="dialog.img" @click="dialog.maximized = !dialog.maximized">
        <img :src="dialog.img.url" width="100%" height="auto"></img>
      </div>
    </q-dialog>


  </page-layout>
</template>
<script>
  import Vue from 'vue'
  import {Dialog, Popover} from 'element-ui'
  import {QDialog, QBtn, QScrollArea} from 'quasar'
  import PageLayout from '../layouts/PageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import PostContainer from '../components/PostContainer'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import commonComputed from 'src/_mixins/CommonComputed'
  import {mapGetters} from 'vuex'
  const VueScrollTo = require('vue-scrollto')
  const baseAction = '/tournaments'
  export default {
    name: 'Tournament',
    components: {
      PostContainer,
      PageLayout, DisplayContainer,
      [Dialog.name]: Dialog,
      [Popover.name]: Popover,
      QDialog, QBtn, QScrollArea,
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | ${this.getTitle}`,
        titleTemplate: '%s',
        meta: this.getSeoMeta
      }
    },
    data () {
      return {
        baseAction: baseAction,
        tournament: null,
        eventIdxs: [],
        loading: true,
        showImgUrl: '',
        dialog: {
          open: false,
          maximized: false,
          img: null
        },
        moreNews: false
      }
    },
    activated () {
      this.getTournament()
    },
//    mounted () {
//      let recaptchaScript = document.createElement('script')
//			recaptchaScript.setAttribute('src', '/statics/event.js')
//			document.head.appendChild(recaptchaScript)
//    },
    beforeRouteUpdate (to, from, next) {
      if (from.params.idx !== to.params.idx) {
        next()
        this.getTournament()
      } else {
        next(false)
      }
    },
    computed: {
      ...commonComputed,
      ...mapGetters([
      ]),
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
      getRouteQueryEvent () {
        return Number(this.$route.query.event)
      },
      getTitle () {
        return this.tournament ? this.tournament.title : ''
      },
      getSeoMeta () {
        return this.tournament ? this.tournament.seo_meta : []
      },
      isExistUSD () {
        return this.tournament && this.tournament.events.length && this.tournament.events.filter(row => row.buy_in_usd).length > 0
      },
      getNewsCnt () {
        const rtn = this.tournament.articles.reduce((acc, cur) => {
          if (cur.idx && cur.idx > 0) acc ++
          return acc
        }, 0)
        return rtn
      },
      getMoreNews () {
        return this.getNewsCnt > 8 && this.moreNews
      },
      getNewsHeight () {
        if (this.getNewsCnt > 8) {
          return this.getMoreNews ? this.getNewsCnt > 100 ? '100%' : this.getNewsCnt > 8 ? '100%' : '100%' : '630px'
        }
      },
    },
    methods: {
      ...CommonMethods,
      getTournament () {
        this.loading = true
        const idx = this.$route.params.idx
        if (this.getRouteQueryEvent) this.eventIdxs = [this.getRouteQueryEvent]
        this.axios.get(baseAction + `/${idx}`).then(rs => {
          let date = ''
          this.tournament = rs.data
          this.tournament.events = this.getEventsRowspan()
          this.loading = false
          setTimeout(() => this.scrollToEventRow(), 500)
        })
      },
      getEventsRowspan () {
        const dateArray = this.cloneData(this.tournament.events)

        let currentCount = 0
        let lastDate = null
        let firstIndex = null

        dateArray.forEach((item, index) => {
          if (item.date !== lastDate) {
            if (currentCount > 1) {
              dateArray[firstIndex].rowspan = currentCount
            }
            dateArray[index].rowspan = 1
            currentCount = 1
            lastDate = item.date
            firstIndex = index
          } else {
            currentCount++
            dateArray[index].rowspan = 0
          }
        });

        // 마지막 연속된 항목에 대한 처리
        if (currentCount > 1) {
          dateArray[firstIndex].rowspan = currentCount
        }
        return dateArray
      },
      clickEventRow (event) {
        if (event.detail || event.imgs.length > 0)
          this.eventIdxs.indexOf(event.idx) > -1 ? this.eventIdxs.splice(this.eventIdxs.indexOf(event.idx), 1) : this.eventIdxs.push(event.idx)
      },
      scrollToEventRow () {
        if (this.getRouteQueryEvent > 0) {
          const el = this.$refs[`event_${this.getRouteQueryEvent}`][0]
          const duration = 600
          VueScrollTo.scrollTo(el, duration, {offset: this.isMobile ? -60 : -159})
        }
      },
      getFileName (file) {
        return file.name ? file.name.toString().substring(0, file.name.toString().lastIndexOf('.')) : ''
      },
      showFile (file) {
        const ext = file.name.toString().substring(file.name.toString().lastIndexOf('.')+1, file.name.toString().length)
        if (ext === 'pdf') {
          const path = file.url.toString().substring(0, file.url.toString().lastIndexOf('/')+1)
          window.open(encodeURI(path + file.name))
        } else {
          this.dialog.img = file
          this.dialog.open = true
        }
      },
      getSeoMetaContent (key) {
        const rtn = this.getSeoMeta ? this.getSeoMeta.find(row => {
          const rowKey = row['name'] ? row['name'] : row['property']
          return rowKey === key
        }) : ''
        return rtn ? rtn.content : ''
      },
      showModal (obj) {
        this.showImgUrl = obj.feed_img.url
        this.$refs.info.show()
      },
      getDaysTabData (data) {
        const rtn =  data.map((row, i) => {
          row.idx = i
          return row
        }).filter(row => {
          return row.is_day
        }).reverse()
        return rtn
      },
    }
  }
</script>


<style scoped>
/*
  .swiper-button-prev,
  .swiper-button-next {
    display: flex;
    align-items: center;
    width: 46px;
    height: 46px;
    border-radius: 100%;
    background: #222;
    box-shadow: 0 10px 10px rgba(0,0,0,.75);
    z-index: 999;
  }
  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 20px;
    font-weight: 900;
    color: #fff;
  }
  .swiper-button-prev {
    left: 15px;
  }
  .swiper-button-next {
    right: 15px;
  }
  .swiper-button-prev:after {
    margin-left: -4px;
  }
  .swiper-button-next:after {
    margin-left: 4px;
  }
*/
  #modal .q-dialog__inner > div {
    max-width: 657px;
    max-height: calc(100vh - 150px);
  }
  .detail_con {
    padding-top: 0;
  }
  .detail_con .tnmt_box .venue_wrap {
    position: relative;
    width: 100%;
    padding: 60px 60px 0;
  }
  .detail_con .tnmt_box .venue {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 140%;
    z-index: 0;
  }
  .detail_con .tnmt_box .venue .img {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }
  .detail_con .tnmt_box .venue .img img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.75;
  }
  .detail_con .tnmt_box .venue:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    display: inline-block;
    width: 100%;
    height: 150px;
    background: linear-gradient(0deg, rgba(0,0,0,1.0) 50%, rgba(0,0,0,0.0));
    z-index: 1;
  }
  .detail_con .tnmt_box h3 {
    width: 75%;
    font-family: 'Montserrat','SUIT Variable';
    font-size: 56px;
    font-weight: 700;
    letter-spacing: -0.03em;
    line-height: 1.0em;
    position: relative;
    z-index: 1;
    margin-bottom: 20px;
  }
  .detail_con .tnmt_box h5 {
    width: 100%;
    font-size: 32px;
    font-weight: 900;
    line-height: 1.0em;
    padding: 40px 0 20px;
  }
  .detail_con .tnmt_box {
    position: relative;
    width: 100%;
    background-color: #000;
    color: #fff;
    border-radius: 8px;
    overflow: hidden;
  }
  .detail_con .tnmt_box:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    width: 100%;
    height: 500px;
    background: linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.98) 85%);
    z-index: 1;
  }
  /*.detail_con .tnmt_box:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, rgba(0,255,100,0) 75%, rgba(0,255,100,0.3));
    z-index: 0;
  }*/
  .detail_con .tnmt_box ul {
    display: inline-block;
    position: relative;
    z-index: 1;
  }
  .detail_con .tnmt_box ul.detail {
    width: 75%;
    font-family: 'Montserrat', 'SUIT Variable';
    letter-spacing: -0.02em;
  }
  .detail_con .tnmt_box ul.detail /deep/ p span {
    font-size: 19px !important;
    color: rgba(255,255,255,0.85);
    font-weight: 500;
  }
  .detail_con .tnmt_box ul.detail /deep/ p:first-child span {
    font-size: 24px !important;
    font-weight: 700;
    color: rgba(255,255,255,1.0);
    letter-spacing: 0em;
  }
  .detail_con .tnmt_box ul.detail > div {
    margin-bottom: 30px;
    line-height: 1.5em;
  }
  .detail_con .tnmt_box ul.logo {
    position: absolute;
    top: 60px;
    right: 60px;
    width: 200px;
    height: 200px;
    border-radius: 8px;
    background: #000;
    overflow: hidden;
  }
  .detail_con .tnmt_box ul.logo:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.2);
    z-index: 1;
  }
  .detail_con .tnmt_box ul.logo .img {
    width: 100%;
    height: 100%;
  }
  .detail_con .tnmt_box ul.logo .img img {
    width: 100%;
    height: 100%;
  }
  .detail_con .tnmt_box .detail {
    font-size: 20px;
    font-weight: 500;
    text-align: left;
  }
  /deep/ .detail_con .tnmt_box .detail li {
    line-height: 1.4em;
    margin-bottom: 15px;
  }
  /deep/ .detail_con .tnmt_box .detail li span {
    font-weight: 700;
  }
  /deep/ .detail_con .tnmt_box .detail li span:after {
    content: ":";
    font-weight: 300;
    padding-left: 10px;
  }
  /deep/ .detail_con .tnmt_box .detail li em {
    padding-left: 5px;
    display: inline-block;
    font-style: normal;
  }
  /deep/ .detail_con .tnmt_box .detail a {
    color: #00ff64;
  }
  /deep/ .detail_con .tnmt_box .detail a:hover {
    text-decoration: underline;
  }
  .detail_con .tnmt_box .detail /deep/ .btn_view {
    display: inline-block;
    font-size: 0.75em;
    font-weight: 700;
    color: #000;
    letter-spacing: 0em;
    padding: 13px 60px 13px 40px;
    background: rgba(0,255,100,1.0);
    border-radius: 4px;
    margin: 4px;
    cursor: pointer;
    transition: .15s;
    position: relative;
  }
  .detail_con .tnmt_box .detail /deep/ .btn_view:after {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border: solid #000;
    border-width: 2px 2px 0 0;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: rotate(45deg) translate(-50%, -30%);
  }
  .detail_con .tnmt_box .detail /deep/ .btn_view:hover {
    background: #92ffbd;
  }
  .detail_con .tnmt_box .detail /deep/ .btn_view span {
    font-size: unset !important;
    font-weight: 700;
    color: #000;
  }
  .detail_con .tnmt_box .detail /deep/ .item-title {
    font-size: 21px;
    font-weight: 900;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 10px 20px;
    background: linear-gradient(to right, rgba(0,255,110,0.2), rgba(255,255,255,0.2));
    border-radius: 5.0em;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    text-transform: uppercase;
  }
  .detail_con .tnmt_box .detail /deep/ .item-title:before {
    content: "";
    display: inline-block;
    width: 30px;
    height: 30px;
    background-image: url(https://www.bluffcatch.com/statics/img/bi_origin.png);
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 10px;
  }
  .detail_con .info_wrap {
    margin: 20px 60px 0;
    position: relative;
    z-index: 1;
  }
  .detail_con .info_wrap .info {
    display: inline-block;
    border-radius: 8px;
    padding: 14px 16px;
    background: rgba(0,0,0,0.35);
    backdrop-filter: blur(10px);
  }
  .detail_con .info_wrap .info p {
    font-size: 14px;
    font-weight: 600;
    color: rgba(255,255,255,0.9);
    letter-spacing: -0.02em;
    line-height: 1.2em;
  }
  .detail_con .info_wrap .info p:before {
    content: "!";
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border: 1px solid #00ff64;
    border-radius: 100%;
    font-size: 13px;
    font-weight: 700;
    color: #00ff64;
    margin-right: 8px;
  }

  /* 신규 콘텐츠 202504 */
  .detail_con .con_series {
    position: relative;
    margin: 30px 60px 40px;
    z-index: 1;
  }
  .detail_con .con_series .section {
    display: inline-block;
    width: 100%;
    padding: 40px;
    background: #ccc;
    margin-bottom: 20px;
    border-radius: 8px;
    background: rgba(27,27,27,0.65);
    backdrop-filter: blur(5px);
  }
  .detail_con .con_series .section .title {
    font-size: 28px;
    font-weight: 900;
    color: #fff;
    line-height: 1.0em;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    margin-bottom: 28px;
  }
  .detail_con .con_series .section .title:before {
    content: "";
    display: inline-block;
    width: 30px;
    height: 30px;
    background-image: url(https://www.bluffcatch.com/statics/img/bi_origin.png);
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 13px;
    position: relative;
    top: -1px;
  }
  .detail_con .con_series .section .ctnr_rep {
    display: flex;
    align-items: center;
    width: 100%;
    background: #252525;
    border-radius: 4px;
    padding: 12px 40px;
    margin-bottom: 6px;
    line-height: 1.0em;
  }
  .detail_con .con_series .section .ctnr_rep:last-child {
    margin-bottom: 0;
  }
  .detail_con .con_series .section .ctnr_rep .event {
    width: 46%;
    font-size: 18px;
    font-weight: 700;
    color: #ccc;
  }
  .detail_con .con_series .section .ctnr_rep a.rep {
    font-size: 16px;
    font-weight: 500;
    color: #999;
    padding: 13px 20px;
    border-radius: 5.0em;
    background: #000;
    margin: 3px;
    transition: .1s;
  }
  .detail_con .con_series .section .ctnr_rep a.rep:hover {
    color: #fff;
    background: #1c5c35;
  }
  .detail_con .con_series .section .sect_wrap.news {
    overflow: hidden;
  }
  .detail_con .con_series .section .ctnr_news {
    display: inline-block;
    width: calc((100% - 60px) / 4);
    margin-right: 20px;
    margin-bottom: 30px;
  }
  .detail_con .con_series .section .ctnr_news:nth-child(4n),
  .detail_con .con_series .section .ctnr_news:last-child {
    margin-right: 0;
  }
/*
  .detail_con .con_series .section .ctnr_news:nth-child(n+9) {
    display: none;
  }
*/
  .detail_con .con_series .section .ctnr_news .img {
    position: relative;
    height: 180px;
    border-radius: 8px;
    overflow: hidden;
  }
  .detail_con .con_series .section .ctnr_news .cate {
    font-size: 14px;
    font-weight: 700;
    color: #666;
    letter-spacing: -0.02em;
    line-height: 1.0em;
    margin: 20px 0 10px;
  }
  .detail_con .con_series .section .ctnr_news .subj {
    font-size: 16px;
    color: #ccc;
    letter-spacing: -0.01em;
    line-height: 1.4em;
    transition: .1s;
  }
  .detail_con .con_series .section .ctnr_news:hover .subj {
    color: #fff;
  }
  .detail_con .con_series .section .ctnr_news:hover .img img {
    filter: brightness(120%);
  }
  .detail_con .con_series .section .lst_more {
    display: block;
    position: relative;
    text-align: center;
    cursor: pointer;
    height: 60px;
    line-height: 58px;
    margin-top: 30px;
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    background: rgba(255,255,255,0.12);
    padding: 0 80px;
    border-radius: 4px;
    transition: all .15s;
  }
  .detail_con .con_series .section .lst_more:hover {
    background: rgba(255,255,255,0.25);
  }
  .detail_con .con_series .section .lst_more:after {
    content: "";
    display: inline-block;
    width: 12px;
    height: 12px;
    border: solid #00ff64;
    border-width: 0 2px 2px 0;
    position: absolute;
    right: 36px;
    top: 50%;
    transform: rotate(45deg) translate(0, -100%);
  }
  .detail_con .con_series .section .ctnr_gallery {
    display: inline-block;
    width: calc((100% - 60px) / 4);
    height: 360px;
    margin-right: 20px;
    margin-bottom: 20px;
    position: relative;
  }
  .detail_con .con_series .section .ctnr_gallery:nth-child(4n),
  .detail_con .con_series .section .ctnr_gallery:last-child {
    margin-right: 0;
  }
  .detail_con .con_series .section .ctnr_gallery .img {
    position: relative;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
  }
  .detail_con .con_series .section .ctnr_gallery .img:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, rgba(0,0,0,0) 50%, rgba(0,0,0,0.95));
  }
  .detail_con .con_series .section .ctnr_gallery .subj {
    font-size: 18px;
    font-weight: 700;
    color: #fff;
    line-height: 1.2em;
    position: absolute;
    left: 25px;
    bottom: 50px;
    padding-right: 25px;
  }
  .detail_con .con_series .section .ctnr_gallery .count {
    font-size: 14px;
    font-weight: 600;
    color: #999;
    position: absolute;
    left: 25px;
    bottom: 25px;
  }
  .detail_con .con_series .section .ctnr_gallery:hover .img img {
    filter: brightness(120%);
  }
  .detail_con .con_series .section .ctnr_info {
    display: inline-block;
    width: calc((100% - 45px) / 4);
    height: 305px;
    background: #00270e;
    margin-right: 15px;
    margin-bottom: 15px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
  }
  .detail_con .con_series .section .ctnr_info:nth-child(4n),
  .detail_con .con_series .section .ctnr_info:last-child {
    margin-right: 0;
  }
  .detail_con .con_series .section .ctnr_info .img {
    position: relative;
    height: 100%;
  }
  .detail_con .con_series .section .ctnr_info .img img {
    object-fit: contain;
  }
  .detail_con .con_series .section .ctnr_info:hover .img img {
    filter: brightness(120%);
  }
  .detail_con .con_series .section .ctnr_pre {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    background: #252525;
    border-radius: 4px;
    padding: 25px 40px;
    margin-bottom: 6px;
    line-height: 1.0em;
    transition: .15s;
  }
  .detail_con .con_series .section .ctnr_pre:last-child {
    margin-bottom: 0;
  }
  .detail_con .con_series .section .ctnr_pre:after {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border: solid #999;
    border-width: 2px 2px 0 0;
    position: absolute;
    right: 35px;
    top: 50%;
    transform: translate(0, -50%) rotate(45deg);
  }
  .detail_con .con_series .section .ctnr_pre p {
    font-size: 16px;
    color: #aaa;
  }
  .detail_con .con_series .section .ctnr_pre .series {
    width: 40%;
    font-size: 18px;
    font-weight: 700;
    color: #ddd;
    letter-spacing: -0.02em;
    line-height: 1.15em;
    padding-right: 40px;
    transition: .15s;
  }
  .detail_con .con_series .section .ctnr_pre .flag {
    width: 9%;
  }
  .detail_con .con_series .section .ctnr_pre .flag img {
    height: 20px;
  }
  .detail_con .con_series .section .ctnr_pre .date {
    width: 25%;
  }
  .detail_con .con_series .section .ctnr_pre:hover {
    background: #2f2f2f;
  }
  .detail_con .con_series .section .ctnr_pre:hover .series {
    color: #fff;
  }
  .market_pop {
    max-width: unset;
    height: auto;
    max-height: unset;
    overflow: hidden;
  }
  .market_pop .close_btn {
		position: absolute;
		top: 30px;
		right: 30px;
		cursor: pointer;
		width: 50px;
		height: 50px;
    border-radius: 100%;
		z-index: 1;
	}
	.market_pop .close_btn:before {
		content: "×";
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 40px;
		font-weight: 300;
		color: #fff;
	}
	.market_pop .close_btn:hover {
		background: #000;
	}
  .market_pop .img {
    width: 74vh;
    height: 74vh;
    position: relative;
  }
  .market_pop .img img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }

  .detail_con .schedule {
    margin-top: 55px;
  }
  .detail_con .schedule h3 {
    font-size: 28px;
    font-weight: 800;
    line-height: 1.0em;
    margin-bottom: 20px;
  }
  .detail_con .sche-table.table-in {
    position: relative;
    z-index: 1;
    width: 100%;
  }
  .detail_con .sche-table.table-in tr.caption {
    background: rgba(255,255,255,0.15);
  }
  .detail_con .sche-table.table-in th {
    color: rgba(255,255,255,0.75);
  }
  .detail_con .sche-table.table-in th:nth-child(4),
  .detail_con .sche-table.table-in th:last-child {
    white-space: nowrap;
  }
  .detail_con .sche-table.table-in th em {
    font-size: 0.8em;
    font-style: normal;
    display: block;
    white-space: nowrap;
  }
  .detail_con .sche-table.table-in th.hide_usd {
    display: none;
  }
  .detail_con .sche-table.table-in .name {
    width: 40%;
  }
  .detail_con .sche-table {
    width: calc(100% - 80px);
    font-size: 16px;
    /*font-family: 'Pretendard';*/
    color: rgba(255,255,255,0.55);
    background: #001e07;
    letter-spacing: -0.01em;
  }
  .detail_con .sche-table tr {
    cursor: pointer;
    transition: .075s;
    position: relative;
  }
  /*.detail_con .sche-table tr.on {
    box-shadow: 0 0 20px rgba(0,0,0,0.95);
  }*/
  /*.detail_con .sche-table tr.on {
    background: rgba(0,0,0,0.24) !important;
  }*/
  /*.detail_con .sche-table tr.on:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-top: 1px solid rgba(255,255,255,0.15);
  }*/
  .detail_con .sche-table tr:nth-child(odd) {
    background: rgba(255,255,255,0.04);
  }
  .detail_con .sche-table tr:hover:after {
    content: "";
    position: absolute;
    top: 0;
    left: 130px;
    right: 0;
    bottom: 0;
    border: 1px solid rgba(0,255,110,0.2);
  }
  .detail_con .sche-table tr.caption:hover:after {
    border: 0;
  }
  .detail_con .sche-table tr.on:hover {
    background: ;
  }
  .detail_con .sche-table tr.caption {
    background: rgba(0,0,0,1.0);
  }
  .detail_con .sche-table th {
    padding: 15px;
    vertical-align: middle;
  }
  .detail_con .sche-table td {
    border-bottom: 0px solid rgba(255,255,255,0.1);
    text-align: center;
    padding: 20px 10px;
    vertical-align: middle;
  }
  .detail_con .sche-table tr.on td {
    vertical-align: inherit;
  }
  .detail_con .sche-table tr.on td.date {
    vertical-align: middle;
  }
  .detail_con .sche-table td.date {
    width: 130px;
    min-width: 130px;
    background: #001e07;
    padding: 20px 17px;
    position: relative;
  }
  .detail_con .sche-table td.date:after {
    content: "";
    display: block;
    width: 1100px;
    height: 1px;
    background: rgba(255,255,255,0.2);
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .detail_con .sche-table td.name {
    width: 35%;
    margin-right: 30px;
    text-align: left;
    font-weight: 700;
    color: rgba(255,255,255,1.0);
    position: relative;
  }
  .detail_con .sche-table td.hide_usd {
    display: none;
  }
  /*.detail_con .sche-table tr.on td.name {
    font-size: 1.4em;
    font-weight: 900;
  }*/
  .detail_con .sche-table tr.red .name {
    color: rgba(255,20,170,1.0);
    background: linear-gradient(to right, rgba(255,0,150,0.0), rgba(255,0,150,0.55));
  }
  .detail_con .sche-table tr.blue .name {
    color: rgba(0,180,255,1.0);
    background: linear-gradient(to right, rgba(0,150,255,0.0), rgba(0,150,255,0.55));
  }
  .detail_con .sche-table tr.green .name {
    color: rgba(0,200,100,1.0);
    background: linear-gradient(to right, rgba(0,255,100,0.0), rgba(0,255,100,0.35));
  }
  /*
  .detail_con .sche-table tr:nth-child(3) .name {
    background: linear-gradient(to right, rgba(0,255,100,0.0), rgba(0,255,100,0.35));
  }
  .detail_con .sche-table tr:nth-child(5) .name {
    color: rgba(0,255,100,1.0);
  }
  .detail_con .sche-table tr:nth-child(7) .name {
    color: rgba(0,150,255,1.0);
    background: linear-gradient(to right, rgba(0,150,255,0.0), rgba(0,150,255,0.55));
  }
  .detail_con .sche-table tr:nth-child(9) .name {
    color: rgba(255,0,120,1.0);
    background: linear-gradient(to right, rgba(255,0,120,0.0), rgba(255,0,120,0.55));
  }
  */
  .detail_con .sche-table tr.on .name {

  }
  .detail_con .sche-table td.name p,
  .detail_con .sche-table td.name span {
    position: relative;
    padding-right: 40px;
    display: block;
  }
  .detail_con .sche-table td.name em {
    display: block;
    font-size: 15px;
    font-weight: 300;
    color: rgba(255,255,255,1.0);
    font-style: normal;
    opacity: 0.55;
  }
  .detail_con .sche-table td.name p:after {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translate(0, -50%);
    display: inline-block;
    width: 12px;
    height: 12px;
    background: url('/statics/img/a_arrow_v.png') no-repeat;
    background-size: contain;
    content: "";
    transition: .15s;
  }
  .detail_con .sche-table .on td.name p:after {
    transform: translate(0, -100%) rotate(180deg);
    filter: brightness(300%) grayscale(100%);
  }
  .detail_con .sche-table td.name .detail {
    margin-top: 20px;
    padding: 20px 0 0 10px;
    font-size: 14px;
    font-weight: 300;
    color: rgba(255,255,255,0.7);
    line-height: 1.7em;
    letter-spacing: 0em;
    border-top: 1px solid rgba(255,255,255,0.2);
    position: relative;
  }
  .detail_con .sche-table td.name .detail /deep/ strong {
    font-weight: 500;
  }

  .detail_con .schedule .lst dl {
  }
  .detail_con .schedule .lst dl dt {
    position: relative;
    cursor: pointer;
    padding: 35px 0;
    max-height: 80px;
    letter-spacing: -0.02em;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: #b9ffd4;
    border: 1px solid transparent;
    transition: .15s;
  }
  .detail_con .schedule .lst dl:nth-child(even) dt {
    background: #e9fff2;
  }
  .detail_con .schedule .lst dl dt:hover {
    border: 1px solid #379339;
    box-shadow: 0 0 4px rgba(0,0,0,0.15);
    filter: brightness(96%);
    z-index: 1;
  }
  .detail_con .schedule .lst dl.on dt {
    color: #379339;
    background: #fff;
    border: 1px solid #000;
    box-shadow: 0 0 4px rgba(0,0,0,0.15);
    z-index: 1;
  }
  .detail_con .schedule .lst dl dt p {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    letter-spacing: -0.03em;
  }
  .detail_con .schedule .lst dl dt p.name {
    font-weight: 800;
    width: 30%;
    margin: 0 10px;
  }
  .detail_con .schedule .lst dl dt:after {
    position: absolute;
    right: 45px;
    top: 50%;
    transform: translate(0, -50%);
    display: inline-block;
    width: 24px;
    height: 21px;
    background: url('/statics/img/a_arrow_v.png') no-repeat;
    background-size: contain;
    filter: brightness(0);
    content: "";
    transition: .15s;
  }
  .detail_con .schedule .lst dl.on dt:after {
    transform: translate(0, -56%) rotate(180deg);
    filter: brightness(100%);
  }
  .detail_con .schedule .lst dl dd {
    background: #fff;
  }
  /deep/ .detail_con .schedule .lst dl dd .in_box {
    padding: 40px;
    font-size: 18px;
    font-weight: 500;
  }
  /deep/ .detail_con .schedule .lst dl dd .in_box p {
    padding: 6px 0;
  }
  /deep/ .detail_con .schedule .lst dl dd .in_box table {
    width: 100%;
  }
  /deep/ .detail_con .schedule .lst dl dd .in_box table a {
    color: #379339 !important;
    font-weight: 700;
    text-decoration: underline;
  }
  /deep/ .detail_con .schedule .lst dl dd .in_box table a:hover {
    color: #000 !important;
  }
  /deep/ .detail_con .schedule .lst dl dd .in_box table {
    margin: 5px 0;
  }
  /deep/ .detail_con .schedule .lst dl dd .in_box table td {
    width: fit-content !important;
    padding: 8px 20px;
    background: #fff;
    font-size: 0.9em;
    font-weight: 500;
		vertical-align: middle;
    border-bottom: 1px solid #eee;
    line-height: 1.8em;
  }
  /deep/ .detail_con .schedule .lst dl dd .in_box table tr:first-child td {
    color: #379339;
    text-transform: uppercase;
    border-top: 1px solid rgba(55,147,57,0.35);
  }
  /deep/ .detail_con .schedule .lst dl dd .in_box table tr:nth-child(even) td {
    background: #fbfbfb;
  }
  .detail_con .schedule .lst_info {
    margin-top: 16px;
  }
  /deep/ .detail_con .schedule .lst_info {
    line-height: 24px;
    font-size: 14px;
    color: #666;
  }
  .detail_con .btn_view_detail {
    display: inline-block;
    font-size: 1.0em;
    font-weight: 800;
    color: #000 !important;
    letter-spacing: -0.03em;
    padding: 8px 35px 8px 20px;
    background: rgba(255,255,255,0.7);
    border-radius: 3px;
    margin: 20px 0;
    cursor: pointer;
    transition: .15s;
    position: relative;
    z-index: 10;
  }
  .detail_con .btn_view_detail:after {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border: solid #000;
    border-width: 2px 2px 0 0;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: rotate(45deg) translate(-50%, -30%);
  }
  .detail_con .btn_view_detail:hover {
    background: #92ffbd;
    text-decoration: none !important;
  }
  .detail_con .connection {
    background: #f5f5f5;
  }
  .detail_con .connection .lst > li {
    margin-top: 40px;
  }
  .detail_con .connection .lst > li .img {
    min-height: 214px;
  }
  .detail_con .connection .lst > li a .data .subj {
    transition: all 0.15s;
  }
  .detail_con .connection .lst > li a:hover .data .subj {
    color: #ffa800;
  }
  .detail_con .connection .lst > li .data {
    position: relative;
    height: 180px;
    padding: 18px 20px;
    text-align: left;
  }
  .detail_con .connection .lst > li .data .date {
    position: absolute;
    left: 20px;
    top: -25px;
    width: 50px;
    height: 50px;
    padding-top: 9px;
    text-align: center;
    background: #ffa800;
    display: none;
  }
  .detail_con .connection .lst > li .data .date i {
    display: block;
    line-height: 16px;
    font-family: "Oswald", 'Malgun Gothic', 'Dotum', sans-serif;
    font-size: 14px;
    color: #fff;
  }
  .detail_con .connection .lst > li .data .subj {
    line-height: 26px;
    font-size: 20px;
    font-weight: bold;
    color: #222;
    letter-spacing: -0.7px;
    word-break: break-all;
		height: 2.6em;
		overflow: hidden;
  }
  .detail_con .connection .lst > li .data .txt {
    line-height: 24px;
    margin-top: 7px;
    font-size: 14px;
    color: #777;
    word-break: break-all;
    max-height: 75px;
  }
  .detail_con .connection .lst_more {
    display: block;
    cursor: pointer;
    width: 360px;
    height: 40px;
    line-height: 39px;
    margin: 40px auto 0;
    font-size: 16px;
    color: #fff;
    text-align: center;
    background: #888;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    transition: all 0.2s;
  }
  .detail_con .connection .lst_more:hover {
    background-color: #666;
  }
  .detail_con .awards {
    background: #fff;
  }
  .detail_con .awards .inner {
    margin-top: 50px;
  }
  .detail_con .awards .lst > li {
    box-shadow: none;
  }
  .detail_con .awards .lst > li .tit {
    display: table;
    width: 100%;
    height: 70px;
    text-align: center;
  }
  .detail_con .awards .lst > li .tit p {
    display: table-cell;
    vertical-align: middle;
    color: #fff;
  }
  .detail_con .awards .lst > li .tit i {
    display: block;
    line-height: 21px;
    font-size: 20px;
    font-weight: bold;
  }
  .detail_con .awards .lst > li .tit strong {
    display: block;
    font-family: "Russo One", "Noto Sans KR", 'Malgun Gothic', 'Dotum', sans-serif;
    font-size: 24px;
		color: #222;
    font-weight: 700;
    letter-spacing: -0.02em;
  }
  .detail_con .awards .lst > li .tit.tit1 {
    background: #f4f4f4;
  }
  .detail_con .awards .lst > li .tit.tit2 {
    background: #f4f4f4;
  }
  .detail_con .awards .lst > li .tit.tit3 {
    background: #f4f4f4;
  }
  /deep/ .detail_con .awards .lst > li .txt p {
    border-bottom: 1px solid #ddd;
  }
	/deep/ .detail_con .awards .lst > li .txt .awds_box {
		width: 100%;
		height: 105px;
		vertical-align: middle;
		padding-left: 102px;
		line-height: 1.9em;
		letter-spacing: -0.03em;
		background-repeat: no-repeat;
		background-size: 60px;
		background-position: 20px 22px;
		border-bottom: 1px solid #949494;
		text-align: left;
  }
	/deep/ .detail_con .awards .lst > li:first-child .txt .awds_box {
    background-image: url('/statics/img/awards_gorilla.png');
    filter: hue-rotate(28deg) brightness(1.2) contrast(1.85);
  }
	/deep/ .detail_con .awards .lst > li:nth-child(2) .txt .awds_box {
    background-image: url('/statics/img/awards_type.png');
    filter: hue-rotate(28deg) brightness(1.2) contrast(1.85);
  }
	/deep/ .detail_con .awards .lst > li:nth-child(3) .txt .awds_box {
    background-image: url('/statics/img/awards_corp.png');
    filter: hue-rotate(28deg) brightness(1.2) contrast(1.85);
  }
	/deep/ .detail_con .awards .lst > li .txt .awds_box .title {
    font-size: 17px;
		color: #333;
		font-weight: 500;
		display: block;
		padding-top: 24px;
  }
	/deep/ .detail_con .awards .lst > li .txt .awds_box .cont {
    font-size: 16px;
		color: #777;
		font-weight: 500;
  }
  .detail_con .detail_tip {
    background: #f5f5f5;
    padding-bottom: 0;
    text-align: center;
  }
  .detail_con .detail_tip .tip_bn1 {
    margin-top: 45px;
    margin-bottom: 90px;
  }
  .detail_con .detail_tip .tip_bn2 {
    padding: 50px 0 110px;
    background: #fff;
    display: none;
  }
  .detail_con .most_compared {
    padding-bottom: 100px;
  }
  .detail_con .most_compared .lst > li {
    position: relative;
    min-height: 470px;
    margin-top: 120px;
    padding-left: 30px;
    padding-right: 30px;
    text-align: center;
    background: #fff;
  }
  .detail_con .most_compared .lst > li a .subj {
    transition: all 0.15s;
  }
  .detail_con .most_compared .lst > li a:hover .subj {
    color: #ffa800;
  }
  .detail_con .most_compared .lst > li .img {
    display: table;
    width: 100%;
    height: 240px;
    margin-top: -90px;
    text-align: center;
  }
  .detail_con .most_compared .lst > li .img i {
    display: table-cell;
    vertical-align: middle;
  }
  .detail_con .most_compared .lst > li .img i img {
    max-width: 240px;
    max-height: 240px;
  }
  .detail_con .most_compared .lst > li .data {
    margin-top: 28px;
    min-height: 250px;
  }
  .detail_con .most_compared .lst > li .num {
    line-height: 40px;
    font-family: "Russo One", 'Malgun Gothic', 'Dotum', sans-serif;
    font-size: 30px;
    color: #ffa800;
    font-style: italic;
  }
  .detail_con .most_compared .lst > li .subj {
    line-height: 28px;
    font-size: 24px;
    font-weight: bold;
    color: #222;
		letter-spacing: -0.04em;
  }
  .detail_con .most_compared .lst > li .brand {
    line-height: 20px;
    margin-top: 7px;
    font-size: 16px;
    font-weight: 500;
    color: #666;
  }
  .detail_con .most_compared .lst > li .price {
    margin-top: 26px;
    font-size: 0;
    color: #777;
  }
  /deep/ .detail_con .most_compared .lst > li .price span {
    font-size: 14px;
  }
  /deep/ .detail_con .most_compared .lst > li .price span:nth-child(n+2):before {
    padding: 0 8px;
    content: "/";
  }
  /deep/ .detail_con .most_compared .lst > li .price b {
    display: inline-block;
    line-height: 17px;
    padding-top: 3px;
    font-family: "Nanum Square", 'Malgun Gothic', 'Dotum', sans-serif;
    font-size: 17px;
    letter-spacing: -0.5px;
    color: #333;
  }
  .detail_con .most_compared .lst > li .more_btn {
    position: absolute;
    left: 30px;
    right: 30px;
    bottom: 40px;
    display: block;
    width: calc(100% - 60px);
    height: 50px;
    top: 340px;
    background: #fff;
    border: 1px solid #222;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    transition: all 0.2s;
    cursor: pointer;
  }
  .detail_con .most_compared .lst > li .more_btn p {
    position: absolute;
    left: 0;
    top: 50%;
    text-align: center;
    width: 100%;
    height: 20px;
    line-height: 18px;
    margin-top: -10px;
    font-size: 18px;
    color: #222;
    font-weight: bold;
    transition: all 0.2s;
  }
  .detail_con .most_compared .lst > li .more_btn:hover {
    background-color: #f5f5f5;
  }
  .detail_con .most_compared .lst > li .more_btn:hover p {
    color: #000;
  }
  .detail_con .most_compared .lst > li .compare_btn {
    position: absolute;
    left: 30px;
    right: 30px;
    bottom: 40px;
    display: block;
    width: calc(100% - 60px);
    height: 42px;
    top: 400px;
    background: #fff;
    border: 1px solid #fff;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    transition: all 0.2s;
    cursor: pointer;
  }
  .detail_con .most_compared .lst > li .compare_btn i {
    position: absolute;
    left: 0;
    top: 50%;
    text-align: center;
    width: 100%;
    height: 20px;
    line-height: 18px;
    margin-top: -10px;
    font-size: 16px;
    color: #666;
    font-weight: 500;
    transition: all 0.2s;
  }
  .detail_con .most_compared .lst > li .compare_btn i:before {
    display: inline-block;
    width: 18px;
    height: 18px;
    margin: 1px 7px 0 0;
    background: url('/statics/img/icon_circle_plus.png');
    content: "";
    filter: hue-rotate(28deg) brightness(1.2) contrast(1.85);
  }
  .detail_con .most_compared .lst > li .compare_btn:hover {
    background-color: #f5f5f5;
  }
  .detail_con .most_compared .lst > li .compare_btn:hover i {
    color: ;
  }
  .detail_con .most_compared .return_more {
    display: block;
    position: relative;
    width: 360px;
    height: 60px;
    margin: 50px auto 0;
    cursor: pointer;
    border: 2px solid #bfbfbf;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    transition: all 0.2s;
  }
  .detail_con .most_compared .return_more i {
    position: absolute;
    left: 0;
    top: 50%;
    text-align: center;
    width: 100%;
    height: 20px;
    line-height: 18px;
    margin-top: -10px;
    font-size: 19px;
    color: #222;
    font-weight: 500;
    transition: all 0.2s;
  }
  .detail_con .most_compared .return_more i:before {
    display: inline-block;
    width: 23px;
    height: 16px;
    margin: 2px 12px 0 0;
    background: url('/statics/img/return_more_icon.png');
    content: "";
    filter: grayscale(1.0) brightness(1.1);
  }
  .detail_con .most_compared .return_more:hover {
    background-color: #dadada;
    border-color: #dadada;
  }
  .detail_con .most_compared .chart_tit {
    margin-top: 104px;
  }
  .detail_con .most_compared .banner {
    margin-top: 100px;
  }
  /*# sourceMappingURL=detail.css.map */

  /** 카고 측에서 전달한 CSS **/
  /* 상세 혜택(아코디언) 내 테이블 스타일 */
  /deep/ .b-table td { padding:15px; line-height:1.7em; color:#666; border-bottom:1px solid #ccc; border-right:1px solid #ccc; border-left: 0; vertical-align:middle; }
  /deep/ .b-table td:last-child { border-right:none; }
  /deep/ .b-table-b { font-weight:500; color:#333 !important; background:#f1f1f1; text-align:center; }
  /deep/ .b-table-top { font-weight:500; color:#333 !important; background:#f1f1f1; text-align:center; border-top:1px solid #777; }
  /deep/ .b-table-br { border-right:1px solid #ccc !important; }
  /deep/ .b-table td strong { font-weight:500; }
  /deep/ .b-table-sm { font-size:0.8em; }

  /* 에디터로 편집한 콘텐츠 하단에 by froala 임의 출력되는 부분 가림  */
  /deep/ .detail_con p[data-f-id='pbf'] { display:none; }

  /* 상세페이지 내 Benefit, Contents 등 가장 큰 영문 폰트 사이즈 줄임, 심의에 영향이 있음 */
  /deep/ .detail_con .cmd_con h3 strong { font-size: 50px; }

  /* 3개 주요혜택 중 숫자로 표시되는 부분(가장 큰 폰트)에 본고딕 폰트 추가. 불가피하게 한글로 표기해야 하는 부분이 있음 */
  /deep/ .detail_con .tnmt_top .bnf1 dl dd strong { font-family: Oswald,Noto Sans KR,Malgun Gothic,Dotum,sans-serif }

  /* 20190321 추가//상세연회비 팝업 하단 by froala 문구 가림/타이틀문구 추가/스타일 수정 */
  .el-popover p:last-child {
    display:none;
  }
  .el-popper .popper__arrow {
    -webkit-filter: drop-shadow(-2px 0 0 rgba(0,0,0,1.0));
    filter: drop-shadow(-2px 0 0 rgb(0, 0, 0, 1.0));
  }
  /deep/ .el-popover p:last-child {
    display:none;
  }

	/* 프로모션 팝업 html 20200521 */
	/deep/ .pop_box {
		position: relative;
    max-width: 640px;
	}
	/deep/ .pop_box .close_btn {
		position: absolute;
		top: 10px;
		right: 10px;
		background: rgba(0,0,0,0.6);
		border-radius: 100%;
		cursor: pointer;
		width: 40px;
		height: 40px;
		z-index: 1;
	}
	/deep/ .pop_box .close_btn:before {
		content: "×";
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-48%, -54%);
		font-size: 26px;
		font-weight: 300;
		color: #fff;
	}
	/deep/ .pop_box .banner {
		background: #fff;
    padding: 30px;
	}
	/deep/ .pop_box .banner img {
		max-width: 100%;
	}
	/deep/ .pop_box .banner a.lt {
		color: #009933;
	}
	/deep/ .pop_box .banner a:hover {
		text-decoration: underline;
	}
	/deep/ .pop_box .banner h3 {
    color: #fff;
    font-size: 24px;
    text-align: center;
    padding: 10px;
    font-weight: 700;
    margin: -30px -30px 30px;
	}
	/deep/ .pop_box .banner h3 p {
    font-size: 0.8em;
		font-weight: 400;
		color: #fff;
		margin-bottom: -15px;
		line-height: 1.4em;
		padding-bottom: 20px;
	}
	/deep/ .pop_box .banner h3.titimg {
    padding: 0;
	}
	/deep/ .pop_box .banner h3.titimg.allimg {
    margin-bottom: -30px;
	}
	/deep/ .pop_box .banner h5 {
    text-align: center;
    line-height: 1.6em;
    margin-bottom: 20px;
    letter-spacing: -0.03em;
	}
	/deep/ .pop_box .banner h5.kb {
    color: #009171;
    font-weight: 500;
	}
	/deep/ .pop_box .banner h6 {
    text-align: center;
    line-height: 1.6em;
    margin-bottom: 20px;
    letter-spacing: -0.02em;
	}
	/deep/ .pop_box .banner h6.kb {
    color: #666;
	}
	/deep/ .pop_box .banner > p {
		font-size: 1.2em;
    color: #666;
    margin-bottom: 20px;
	}
	/deep/ .pop_box .banner > p.title {
		font-size: 1.3em;
    font-weight: 700;
		color: #222;
		margin-bottom: 5px;
	}
	/deep/ .pop_box .banner > p.title.tit-s {
		font-size: 1.1em;
		font-weight: 700;
		color: #555;
		margin-bottom: 10px;
	}
	/deep/ .pop_box .banner > p.event {
		font-size: 1.3em;
		font-weight: 700;
		color: #fff;
    line-height: 1.0em;
    background: #000;
    display: inline-block;
    padding: 8px 20px 10px;
    border-radius: 5.0em;
		margin-bottom: 20px;
	}
	/deep/ .pop_box .banner > p.event-tit {
		font-size: 1.5em;
		font-weight: 700;
    color: #000;
    letter-spacing: -0.02em;
    line-height: 1.70em;
    display: inline-block;
    margin-left: 10px;
	}
	/deep/ .pop_box .banner > p.event-subj {
		font-size: 1.3em;
		font-weight: 700;
		color: #222;
		margin-bottom: 0;
    background: #f1f1f1;
    padding: 12px 20px;;
	}
	/deep/ .pop_box .banner > p em {
		font-size: 0.9em;
		font-style: normal;
    font-weight: 700;
		color: #999;
    letter-spacing: -0.02em;
    margin-top: 6px;
    display: inline-block;
	}
	/deep/ .pop_box .banner > p span {
		display: block;
		font-size: 0.85em;
		font-weight: 700;
		color: #999;
		line-height: 1.4em;
		margin-top: 8px;
		padding-left: 24px;
		position: relative;
	}
	/deep/ .pop_box .banner > p span:before {
		content: "!";
		display: inline-block;
		color: #fff;
		background: #bbb;
		width: 18px;
		height: 18px;
		text-align: center;
		border-radius: 100%;
		line-height: 1.4em;
		font-weight: 500;
		margin-right: 6px;
		position: absolute;
		left: 0;
	}
  /deep/ .pop_box .banner > p .exc:before {
		content: "!";
		display: inline-block;
		color: #fff;
		background: #666;
		width: 18px;
		height: 18px;
		text-align: center;
		border-radius: 100%;
		line-height: 1.2em;
    font-size: 0.8em;
		font-weight: 500;
		margin-right: 6px;
    margin-top: 0.2em;
	}
	/deep/ .pop_box .banner > p.item {
		padding-left: 10px;
		margin: 4px 0;
		position: relative;
	}
	/deep/ .pop_box .banner > p.item.none {
		padding-left: 0;
	}
	/deep/ .pop_box .banner > p.item.last {
		margin-bottom: 20px;
	}
	/deep/ .pop_box .banner > p.item:before {
		content: "-";
		position: absolute;
		left: 0;
	}
	/deep/ .pop_box .banner > p.item.st:before {
		content: "*";
	}
	/deep/ .pop_box .banner > p.item.none:before {
		content: "";
	}
	/deep/ .pop_box .banner > p.lpad {
		padding-left: 44px;
		position: relative;
	}
	/deep/ .pop_box .banner > p.lpad:before {
		position: absolute;
		left: 0;
	}
	/deep/ .pop_box .banner > p.lpad.cha-1:before {
		content: "신규 :";
	}
	/deep/ .pop_box .banner > p.lpad.cha-2:before {
		content: "추가 :";
	}
	/deep/ .pop_box .banner ul.conbox {
		padding: 15px 20px;
		background: #f5f5f5;
		margin-bottom: 15px;
	}
  /deep/ .pop_box .banner ul.pdlt {
		padding-left: 17px;
	}
	/deep/ .pop_box .banner > p li {
		font-size: 1.0em;
		color: #666;
	}
	/deep/ .pop_box .banner li {
		font-size: 0.95em;
		color: #777;
		padding-left: 10px;
		margin: 4px 0;
		position: relative;
		letter-spacing: -0.02em;
		word-break: break-all;
	}
	/deep/ .pop_box .banner li.none {
		padding-left: 0;
	}
	/deep/ .pop_box .banner li.none:before {
		content: "";
	}
	/deep/ .pop_box .banner li:before {
		content: "-";
		position: absolute;
		left: 0px;
	}
	/deep/ .pop_box .banner li.dot:before {
		content: "·";
	}
	/deep/ .pop_box .banner li.bold {
		font-size: 1.05em;
		font-weight: 700;
		line-height: 1.3em;
	}
	/deep/ .pop_box .banner li.b {
		font-weight: bold;
	}
	/deep/ .pop_box .banner li.ref {
		padding-left: 17px;
	}
	/deep/ .pop_box .banner li.ref:before {
		content: "※";
	}
	/deep/ .pop_box .banner li.ref {
		padding-left: 17px;
	}
	/deep/ .pop_box .banner li.st:before {
		content: "*";
	}
	/deep/ .pop_box .banner .button {
		display: block;
		text-align: center;
	}
	/deep/ .pop_box .banner .button.pc {
		display: block;
	}
	/deep/ .pop_box .banner .button.m {
		display: none;
	}
	/deep/ .pop_box .banner .button i {
		font-size: 1.2em;
    font-weight: 500;
    color: #222;
    margin-bottom: 10px;
    display: inline-block;
	}
	/deep/ .pop_box .banner .button a {
		display: inline-block;
		width: 50%;
		font-size: 18px;
		font-weight: 700;
		color: #fff;
		background: #000;
		padding: 15px 30px;
		border-radius: 3px;
		margin-top: 20px;
		margin-bottom: 10px;
	}
	/deep/ .pop_box .banner .button a.sub {
		width: 36%;
		background: #777;
		margin-right: 10px;
	}
	/deep/ .pop_box .banner .button a.kb {
		color: rgba(0,0,0,0.85);
    font-weight: 500;
		background: #ffc000;
    margin: 10px 0;
	}
	/deep/ .pop_box .banner .button a.kb2 {
		color: rgba(0,0,0,0.85);
    font-weight: 500;
		background: #84c848;
   margin: 10px 0;
	}
	/deep/ .pop_box .banner .button a.kb3 {
		color: rgba(0,0,0,0.85);
    font-weight: 500;
		background: #7ea4e3;
    margin: 10px 0;
	}
	/deep/ .pop_box .banner .button a.kb4 {
		color: rgba(0,0,0,0.85);
    font-weight: 500;
		background: #7ebce3;
    margin: 10px 0;
	}
	/deep/ .pop_box .banner .button a:hover {
		opacity: 0.8;
	}
	/deep/ .pop_box .banner div.con_box {
		background: #fafafa;
		padding: 20px 20px;
		border-radius: 5px;
		margin-bottom: 5px;
		width: 100%;
	}
	/deep/ .pop_box .banner div.con_box p {
		font-size: 16px;
		color: #444;
	}
	/deep/ .pop_box .banner div.container {
		background: #f1f1f1;
		padding: 10px 20px;
		border-radius: 5px;
		font-size: 16px;
		color: #333;
		font-weight: 700;
		margin-top: 10px;
		display: table;
		width: 100%;
    min-height: 96px;
	}
	/deep/ .pop_box .banner div.container span {
		display: table-cell;
		vertical-align: middle;
	}
	/deep/ .pop_box .banner div.container span em {
		display: block;
    font-size: 0.85em;
    font-weight: 500;
    color: #517bae;
    margin-top: 0.2em;
    line-height: 1.2em;
    font-style: normal;
	}
	/deep/ .pop_box .banner div.container span:first-child {
		padding-right: 20px;
		width: 100px;
		text-align: center;
	}
	/deep/ .pop_box .banner div.container span img {
		max-width: 80px;
		max-height: 76px;
	}
	/deep/ .pop_box .banner div.container a {
		display: inline-block;
		font-size: 12px;
		font-weight: 500;
		color: #fff;
		background: #555;
		padding: 10px 15px;
		border-radius: 3px;
		float: right;
	}
	/deep/ .pop_box .banner div.container a.btn_2nd {
		background: #000;
    margin-right: 3px;
	}
	/deep/ .pop_box .banner div.container a.kb {
		color: #000;
		background: #ffc000;
	}
	/deep/ .pop_box .banner div.container a:hover {
		opacity: 0.8;
	}
  /deep/ .pop_box .banner div.container.table {
		background: #fff;
		padding: 10px;
    border-bottom: 1px solid #ddd;
    min-height: unset;
    margin-top: 0;
	}
  /deep/ .pop_box .banner div.container.table span {
		width: unset;
    font-weight: normal;
	}
  /deep/ .pop_box .banner div.container.table span:first-child {
    text-align: left;
    width: 50%;
    padding-left: 20px;
	}
	/deep/ .pop_box .banner p.container_detail {
		font-size: 1.0em;
    margin-top: 0.4em;
	}
	/deep/ .pop_box .banner p.container_detail b {
		font-size: 1.1em;
    color: #000;
    line-height: 1.6em;
	}
	/deep/ .pop_box .banner .contents {
    width: 400px;
  }
	/deep/ .pop_box .banner .contents .data {
    position: relative;
    padding: 25px 0 10px;
  }
  /deep/ .pop_box .banner .contents .category {
    position: absolute;
    left: 20px;
    top: -11px;
    height: 22px;
    line-height: 21px;
    padding: 0 12px 0 10px;
    font-size: 12px;
    color: #fff;
    font-style: italic;
    font-weight: 500;
    background: #ffa800;
  }
  /deep/ .pop_box .banner .contents .subj-first {
    display: inline-block;
    line-height: 1.4em;
    font-size: 24px;
    color: #313639;
    font-weight: 600;
    letter-spacing: -1px;
    word-break: break-all;
  }
  /deep/ .pop_box .banner .contents .subj {
    display: inline-block;
    line-height: 1.4em;
    font-size: 20px;
    color: #313639;
    font-weight: 700;
    letter-spacing: -0.05em;
    word-break: break-all;
  }
  /deep/ .pop_box .banner .contents .date_area {
    line-height: 30px;
    margin-top: 6px;
  }
  /deep/ .pop_box .banner .contents .date_area:after {
    display: block;
    clear: both;
    content: "";
  }
  /deep/ .pop_box .banner .contents .date_area i {
    float: left;
    font-family: "Oswald", 'Malgun Gothic', 'Dotum', sans-serif;
    font-size: 13px;
    font-weight: 400;
  }
  /deep/ .pop_box .banner .contents .date_area .date {
    margin-right: 10px;
    color: #777;
  }
  /deep/ .pop_box .banner .contents .date_area .writer {
    margin-right: 8px;
    color: #222;
  }
  /deep/ .pop_box .banner .contents .date_area .writer:before {
    color: #777;
    content: "By ";
  }
  /deep/ .pop_box .banner .contents .date_area .writer_img {
    width: 30px;
    height: 30px;
    overflow: hidden;
    border-radius: 100%;
  }
	/deep/ .pop_box .banner .contents .con {
    line-height: 22px;
    margin-top: 27px;
    font-size: 14px;
    color: #222;
    word-break: break-all;
    text-align: justify-all;
    overflow: hidden;
    max-height: 6.2em;
  }
	/deep/ .pop_box .banner .kb_box {
    position: relative;
    padding: 30px 30px 30px 62px;
    border: 1px solid #dcdcdc;
  }
	/deep/ .pop_box .banner .kb_box p {
    font-size: 15px;
    font-weight: 500;
    color: #333;
    line-height: 18px;
    margin-bottom: 22px;
  }
	/deep/ .pop_box .banner .kb_box p:nth-child(2) {
    margin-bottom: 0;
  }
	/deep/ .pop_box .banner .kb_box p:before {
    font-family: 'arial';
    font-weight: 500;
    font-size: 14px;
    color: #fff;
    line-height: 18px;
    background: #1a889d;
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 2.0em;
    text-align: center;
    position: absolute;
    left: 30px;
  }
	/deep/ .pop_box .banner .kb_box p:nth-child(1):before {
    content: "1";
  }
	/deep/ .pop_box .banner .kb_box p:nth-child(2):before {
    content: "2";
  }
	/deep/ .pop_box .banner .kb_box span {
    font-size: 0.9em;
    font-weight: 500;
    color: #1a889d;
    margin-top: 10px;
    display: inline-block;
  }
	/deep/ .pop_box .banner .kb_box span:before {
    content: "-";
    font-weight: 700;
    color: #1a889d;
    position: absolute;
    left: 52px;
  }

	/* 공유 팝업 20200728 */
	.share_pop {
    position: relative;
    width: unset !important;
		height: unset !important;
		max-width: 360px;
    background: #fff;
    border-radius: 5px;
    overflow: hidden;
		padding: 45px 25px 35px;
  }
  .share_pop .close_btn {
    position: absolute;
    right: 12px;
    top: 12px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    font-size: 0;
    text-indent: -9999px;
    background: url(/statics/img/close_01.png);
		background-size: 100%;
  }
	.share_pop ul li {
		position: relative;
		font-size: 12px;
		text-align: center;
		display: inline-block;
		width: 25%;
		margin-bottom: 20px;
		cursor: pointer;
	}
	.share_pop ul li:nth-child(5), .share_pop ul li:nth-child(6), .share_pop ul li:nth-child(7), .share_pop ul li:nth-child(8) {
		margin-bottom: 0;
	}
	.share_pop ul li:hover i {
		box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.2);
	}
	.share_pop ul li i {
		display: inline-block;
		width: 50px;
		height: 50px;
		background-size: 100%;
		background-position: center;
		border-radius: 5%;
		margin-bottom: 5px;
	}
	.share_pop ul li.kakaotalk i {
		background-image:  url('/statics/img/icon_share_kakaotalk.png');
	}
	.share_pop ul li.kakaostory i {
		background-image:  url('/statics/img/icon_share_kakaostory.png');
	}
	.share_pop ul li.facebook i {
		background-image:  url('/statics/img/icon_share_facebook.png');
	}
	.share_pop ul li.twitter i {
		background-image:  url('/statics/img/icon_share_twitter.png');
	}
	.share_pop ul li.naver i {
		background-image:  url('/statics/img/icon_share_naver.png');
	}
	.share_pop ul li.band i {
		background-image:  url('/statics/img/icon_share_band.png');
	}
	.share_pop ul li.line i {
		background-image:  url('/statics/img/icon_share_line.png');
	}
	.share_pop ul li.link i {
		background-image:  url('/statics/img/icon_share_link.png');
	}
	#shareUrl {
		position: absolute;
		top: -9999px
	}
  .p-hide {
    display: none;
   }
</style>
